import type { TableColumns } from '@ohpen/enso-ui';

import type { ParameterEntry } from '@config/interfaces';

/** The systems the parameters came from, so the filter offers exactly those. */
export const SOURCE_LIST_NAME = 'parameterSources';

export const parameterColumns: TableColumns<ParameterEntry> = [
  {
    title: 'config.columns.source',
    dataIndex: 'source',
    key: 'source',
    width: 140,
    options: { filter: 'select', listName: SOURCE_LIST_NAME, sorter: true, filterOptions: { allowedModes: ['anyMatches'] } },
  },
  {
    title: 'config.columns.parameter',
    dataIndex: 'name',
    key: 'name',
    width: 360,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  { title: 'config.columns.value', dataIndex: 'value', key: 'value', options: { filter: 'search' } },
];
